import React from 'react';
import {Input} from "antd";

function FormInput(
    {
        allowClear,
        value,
        type,
        bordered = false,
        defaultValue,
        maxLength,
        showCount,
        onChange,
        onPressEnter,
        ...props
    }
) {
    return (
        <Input
            type={type}
            allowClear={allowClear}
            bordered={bordered}
            showCount={showCount}
            defaultValue={defaultValue}
            maxLength={maxLength}
            onChange={e => onChange(e.target.value)}
            onPressEnter={e => onPressEnter ? onPressEnter(e.target.value) : () => {}}
            value={value}
            {...props}
        />
    );
}

export default FormInput;
